import { FormTemplateTypeEnum } from "../_common/enum/forms/formTemplateType.enum";

export const quoteTypeOrder: FormTemplateTypeEnum[] = [
    FormTemplateTypeEnum.LifeInsurance,
    FormTemplateTypeEnum.MortgageProtection,
    FormTemplateTypeEnum.IncomeProtection,
    FormTemplateTypeEnum.ExecutiveIncomeProtection,
    FormTemplateTypeEnum.SeriousIllnessProtection,
    FormTemplateTypeEnum.Mortgages,
];
